import React from 'react';
import { ButtonGroup } from 'react-bootstrap';
import Submit from './buttons/Submit';
import Listen from './buttons/Listen';
import VoiceSelect from './buttons/VoiceSelect';

const MessageFunctions = () => {
    return (
        <ButtonGroup>
            <Submit />
            <Listen />
            <VoiceSelect />
        </ButtonGroup>
    );
};

export default MessageFunctions;
